const Constants = [
  {
    field_name: "section",
    label: "Section",
    type: "string",
    isRequired: true,
  },
  // {
  //     field_name: 'module',
  //     label: 'Module',
  //     type: "string",
  //     isRequired: true
  // },
  // {
  //     field_name: 'Submodule',
  //     label: 'Sub Module',
  //     type: "string",
  //     isRequired: true
  // },
  {
    field_name: "subSection",
    label: "Sub Section",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "Priority",
    label: "Priority",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "IssueSummary",
    label: "Issue Summary",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "IssueDescription",
    label: "Issue Description",
    type: "string",
    isRequired: true,
  },
  // {
  //     field_name: 'Attachments',
  //     label: 'Attachments',
  //     type: "string",
  //     isRequired: true
  // },
];

export const Constant = {
  Constants,
};
